import _objectSpread from "E:\\Workspaces\\VScode\\vue3+TS\\vue\u6848\u4F8B\\cloudMusicProject-master\\node_modules\\@babel\\runtime\\helpers\\esm\\objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { ref, watch, computed } from "vue";
import { formatLyric } from "@/utils/player/format";
import { gotoArtistDetail, gotoAlbumDetail } from "@/utils/player/routerPush";
import { useStore } from "vuex";
export default /*#__PURE__*/_defineComponent({
  props: {
    song: {
      type: null,
      required: true
    },
    lyric: {
      type: String,
      required: true
    },
    transLyric: {
      type: String,
      required: false
    },
    lyricUser: {
      type: null,
      required: false
    },
    transLyricUser: {
      type: null,
      required: false
    }
  },
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    expose();
    var props = __props;
    var store = useStore();
    /** 滚动条ref */

    var scrollBarRef = ref();
    /** 当前播放的歌词的索引 */

    var currentLyricIndex = ref(0);
    /** 格式化后的歌词数组 */

    var formatedLyrics = computed(function () {
      if (!props.transLyric) {
        return formatLyric(props.lyric);
      } else {
        var lyricList = formatLyric(props.lyric);
        var transLyricList = formatLyric(props.transLyric);
        return lyricList.map(function (item) {
          var findResult = transLyricList.find(function (transItem) {
            return item.time === transItem.time;
          });

          if (findResult) {
            return _objectSpread(_objectSpread({}, item), {}, {
              transText: findResult.text
            });
          }

          return item;
        });
      }
    });
    /** 歌曲当前播放时间 */

    var lyricClass = function lyricClass(text, index) {
      return {
        "text-[16px] text-gray-900 font-medium": currentLyricIndex.value === index - 1 && !text.includes("作词") && !text.includes("作曲")
      };
    };

    watch(function () {
      return store.state.player.currentTime;
    }, function (newTime, oldTime) {
      if (newTime !== oldTime) {
        /** 获取比当前播放时间大的第一个元素 */
        for (var i = 0; i < formatedLyrics.value.length; i++) {
          if (Math.floor(formatedLyrics.value[i].time) === Math.floor(store.state.player.currentTime)) {
            currentLyricIndex.value = i - 1;
            break;
          } else if (Math.floor(formatedLyrics.value[i].time) > Math.floor(store.state.player.currentTime)) {
            currentLyricIndex.value = i - 2;
            break;
          }
        }

        var height = 0;

        if (currentLyricIndex.value !== 0) {
          var lyricEles = document.querySelectorAll(".lyric-item");
          lyricEles.forEach(function (ele, index) {
            if (currentLyricIndex.value >= index) {
              height += ele.clientHeight;
            }
          });

          if (height >= 160) {
            var _scrollBarRef$value;

            (_scrollBarRef$value = scrollBarRef.value) === null || _scrollBarRef$value === void 0 ? void 0 : _scrollBarRef$value.setScrollTop(height - 160 + 20);
          }
        }
      }
    });
    var __returned__ = {
      props: props,
      store: store,
      scrollBarRef: scrollBarRef,
      currentLyricIndex: currentLyricIndex,
      formatedLyrics: formatedLyrics,
      lyricClass: lyricClass,
      gotoArtistDetail: gotoArtistDetail,
      gotoAlbumDetail: gotoAlbumDetail
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});